import { OptionsPillGroup } from "@/components/ui/buttons/OptionsPillGroup";
import { useGetMilkOptions } from "@/hooks/requests/milk/use-get-milk-options";
import { IonSkeletonText } from "@ionic/react";

interface MilkPreferenceGroupProps {
  selectedOptions: Set<string>;
  onToggleOption: (option: string) => void;
  disabled?: boolean;
}

export const MilkPreferenceGroup: React.FC<MilkPreferenceGroupProps> = ({
  selectedOptions,
  onToggleOption,
  disabled = false,
}) => {
  const { milkOptions, isLoading } = useGetMilkOptions();

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4">
        <IonSkeletonText animated className="h-6 w-32 rounded" />
        <div className="flex flex-wrap gap-3">
          {Array.from({ length: 4 }).map((_, i) => (
            <IonSkeletonText
              key={i}
              animated
              className="h-10 w-24 rounded-full"
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <OptionsPillGroup
      label="Milk Preference"
      options={milkOptions ?? []}
      selectedOptions={selectedOptions}
      onToggleOption={onToggleOption}
      disabled={disabled}
    />
  );
};
